import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/ReportDetails.css";

const ReportDetails = () => {

    const navigate = useNavigate();
    const { id } = useParams();

    return (

        <div className="report-details-page">

            <div className="report-details-header">

                <div>

                    <h1>Report Details</h1>

                    <p>

                        Report ID :
                        <strong> {id}</strong>

                    </p>

                </div>

                <button
                    className="back-btn"
                    onClick={() => navigate(-1)}
                >
                    ← Back
                </button>

            </div>

            <div className="report-details-grid">

                <div className="detail-card">

                    <h3>Revenue Summary</h3>

                    <p>Total Revenue</p>

                    <h2>₹0</h2>

                </div>

                <div className="detail-card">

                    <h3>Orders</h3>

                    <p>Total Orders</p>

                    <h2>0</h2>

                </div>

                <div className="detail-card">

                    <h3>Customers</h3>

                    <p>Total Customers</p>

                    <h2>0</h2>

                </div>

                <div className="detail-card">

                    <h3>Providers</h3>

                    <p>Total Providers</p>

                    <h2>0</h2>

                </div>

            </div>

            <div className="report-section">

                <h3>Revenue Breakdown</h3>

                <p>
                    Revenue analytics chart will be displayed
                    here.
                </p>

            </div>

            <div className="report-section">

                <h3>Order Statistics</h3>

                <p>
                    Order analytics chart will be displayed
                    here.
                </p>

            </div>

            <div className="report-section">

                <h3>Payment Statistics</h3>

                <p>
                    Payment analytics chart will be displayed
                    here.
                </p>

            </div>

            <div className="report-section">

                <h3>Top Selling Foods</h3>

                <table className="details-table">

                    <thead>

                        <tr>

                            <th>Food</th>

                            <th>Orders</th>

                            <th>Revenue</th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr>

                            <td colSpan="3">

                                No Data Available

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>

            <div className="report-section">

                <h3>Top Providers</h3>

                <table className="details-table">

                    <thead>

                        <tr>

                            <th>Provider</th>

                            <th>Orders</th>

                            <th>Revenue</th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr>

                            <td colSpan="3">

                                No Data Available

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default ReportDetails;